export default __webpack_public_path__ + "static/theme-chooser-4ef262a76ae933256db994abb7bbc7d8.png";